import { PublicUserFragment } from '@client/graphql/__generated__/types';
import { createContext, useContext } from 'react';

interface SharedPageContextType {
  isForPdf?: boolean;
  sharedBy?: PublicUserFragment;
}

export const SharedPageContext = createContext<SharedPageContextType>({});

export const useSharedPageContext = () => {
  return useContext(SharedPageContext);
};
